import {AfterViewInit, Component, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {SectionContactComponent} from '../../contact/component/section-contact/section-contact.component';
import {SectionTopComponent} from '../../section/component/top/section-top.component';
import {SectionFeaturesComponent} from '../../section-features/component/section-features.component';
import {SectionServicesComponent} from '../../section-services/component/section-services.component';
import {SectionTechnologiesComponent} from '../../section-technologies/component/section-technologies.component';
import {SectionTestimonialsComponent} from "../../section-testimonials/testimonials/section-testimonials.component";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('section', {read: ViewContainerRef})
  section!: ViewContainerRef;

  private components: Array<Type<any>> = [
    SectionTopComponent,
    SectionFeaturesComponent,
    SectionServicesComponent,
    SectionTechnologiesComponent,
    SectionContactComponent
  ];
  private componentIndex = 0;

  constructor() {
  }

  onScroll() {
    if (this.componentIndex < this.components.length) {
      this.section.createComponent(this.components[this.componentIndex]);
      this.componentIndex += 1;
    }
  }

  ngAfterViewInit(): void {
    this.section.clear();
    this.section.createComponent(this.components[this.componentIndex]);
    this.componentIndex += 1;
  }
}
